import { ApiError } from './api'

/**
 * What a failed save should show: a message for each input the server pointed at (by its field
 * name, e.g. `postalCode`) and a general message for everything else.
 */
export type FormErrors = { fields: Record<string, string>; general: string | null }

export function formErrors(err: unknown, fallback: string): FormErrors {
  const fields: Record<string, string> = {}
  if (err instanceof ApiError && Array.isArray(err.details)) {
    for (const d of err.details as { path?: string; message?: string }[]) {
      if (d?.path && d.message && !(d.path in fields)) fields[d.path] = d.message
    }
  }
  if (Object.keys(fields).length > 0) return { fields, general: null }
  return { fields, general: err instanceof Error ? err.message : fallback }
}

export const noErrors: FormErrors = { fields: {}, general: null }
